import { useGoogleAnalytics } from './useGoogleAnalytics'

export const GoogleAnalyticsProvider = () => {
  useGoogleAnalytics()
  return null
}
